import CancelSubscriptionSuccess from "../personal/CancelSubscriptionSuccess"

export type SubscriptionSchoolCancelConfirmProps = {}

const SubscriptionSchoolCancelSuccess: React.FC<
  SubscriptionSchoolCancelConfirmProps
> = () => {
  return <CancelSubscriptionSuccess />
}

export default SubscriptionSchoolCancelSuccess
